import React from 'react';
export function ViewListIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11V4h7v7H2zm2-5h3v3H4V6zM2 21v-7h7v7H2zm2-5h3v3H4v-3z"
  }), React.createElement("path", {
    d: "M22 16H11v-2h11v2zM11 6h11V4H11v2zm5 14h-5v-2h5v2zm-5-10h5V8h-5v2z"
  }));
}